import 'react-dates/css/styles.scss'
import '../Referral/Referral.scss'
import './StatusContractForm.scss'
import ReferralAgentSuccessHeader from 'manager/common/AgentSuccess'

import React, {Component} from 'react'
import {
  AGENT_CONTRACT_STATUS_CONTRACT_BROKEN,
  AGENT_STATUS_CONTRACT,
  AGENT_SUCCESS_TOUCH_STAGES,
  ANSWER_TYPE,
  QUESTION_TYPE,
} from 'common/constants'
import {connect} from 'react-redux'
import {
  checkReferralStatusFormValid,
  fetchSearchConfig,
  markFieldBlurred,
  resetBlurredFields,
  saveStatus,
  setField
} from 'manager/redux/referral_status'
import {ContractChangeRequiredModal} from 'manager/views/components/Referral/ContractChangeRequiredModal'
import {ContractConfirmModal} from 'manager/views/components/ReferralStatus/ContractConfirmModal'
import {ContractStatusChoices} from 'manager/views/components/ReferralStatus/ContractStatusChoices'
import {createStructuredSelector} from 'reselect'
import {DatePicker} from 'manager/views/components/ReferralStatus/SingleDatePicker'
import {fromCurrency, scrollToTop, toCurrency} from 'manager/util/helper'
import {NoteField} from 'manager/views/components/ReferralStatus/NoteField'
import {
  selectContractAmount,
  selectContractAmountErrorMsg,
  selectContractCloseDate,
  selectContractCloseDateErrorMsg,
  selectContractMLS,
  selectContractMlsErrorMsg,
  selectContractPropertyAddr,
  selectContractStatus,
  selectHasTourInfoOrValidNote,
  selectIsUpdatingContract,
  selectNote,
  selectSettlement,
  selectSettlementNewSelectionCompany,
  selectValidContractAmended,
  selectValidContractAmount,
  selectValidContractCloseDate,
  selectValidContractMLS,
  selectValidContractPropertyAddress,
  selectValidContractStatus,
} from 'manager/selectors/referral_status_selectors'
import {show} from 'redux-modal'
import {StatusSubmitButton} from 'manager/views/components/ReferralStatus/StatusSubmitButton'

import AddressAutocomplete from 'common/views/atoms/AddressAutocomplete/AddressAutocomplete'
import FeedbackTextbox from 'common/views/components/FeedbackTextbox'
import PropertyTourQuestions from 'manager/views/components/ReferralStatus/PropertyTourQuestions'
import ReferralQualiaQuestions from "manager/views/components/ReferralStatus/ReferralQualiaQuestions"
import {
  selectAssignmentTransactionHash,
  selectIsLease,
  selectIsPropertyInquiryTourUpdateNeeded,
  selectIsTitlePlacedOrderQuestionAnsweredNo,
  selectIsTitlePlaceOrderNowAnsweredYes,
  selectIsTitleWillYouSelectQuestionAnsweredYes,
  selectLatestQualiaOrder,
  selectReferralQualiaAskAgentQuestion,
  selectReferralQualiaEnabled,
  selectShouldShowFirstContractSuccess,
  selectTitlePlacedOrderQuestion,
  selectTitlePlaceOrderNowQuestion,
  selectTitleProviderIsQualia,
  selectTitleWhoIsProviderQuestion,
  selectTitleWillYouSelectQuestion,
} from 'manager/selectors/referral_selectors'
import _ from "lodash"

let validateTimeoutId = null

class ContractForm extends Component {

  state = {
    saveStatusInProgress: false
  }

  handleSave = async () => {
    const {
      saveStatus,
      note,
      contract_mls,
      contract_property_address,
      contract_amount,
      contract_close_date,
      contract_status,
      isSelectedQualiaProvider,
      titleWillYouSelectAnswer,
      isTitleWillYouSelectQuestionAnsweredYes,
      titleWhoIsProviderAnswer,
      titlePlacedOrderAnswer,
      isTitlePlacedOrderQuestionAnsweredNo,
      titlePlaceOrderNowAnswer,
      newSelectionCompany,
      selectSettlement,
      shouldAskAgentQuestion,
    } = this.props

    let payload = {
      note,
      contract_mls,
      contract_property_address,
      contract_amount,
      contract_close_date,
      contract_status,
    }

    if (shouldAskAgentQuestion && contract_status !== AGENT_CONTRACT_STATUS_CONTRACT_BROKEN) {
      let settlement_new_selection_company = null
      let title_questions = {[QUESTION_TYPE.TITLE_WILL_YOU_SELECT]: titleWillYouSelectAnswer}
      if (isTitleWillYouSelectQuestionAnsweredYes) {

        if (titleWhoIsProviderAnswer) {
          title_questions[QUESTION_TYPE.TITLE_WHO_IS_PROVIDER] = titleWhoIsProviderAnswer

          if (isSelectedQualiaProvider) {
            title_questions[QUESTION_TYPE.TITLE_PLACED_ORDER] = titlePlacedOrderAnswer

            if (titlePlacedOrderAnswer && isTitlePlacedOrderQuestionAnsweredNo) {
              title_questions[QUESTION_TYPE.TITLE_PLACE_ORDER_NOW] = titlePlaceOrderNowAnswer
            }
          }

          settlement_new_selection_company = newSelectionCompany
        }
      }

      payload.title_questions = title_questions
      payload.settlement = selectSettlement
      payload.settlement_new_selection_company = settlement_new_selection_company
    }

    try {
      this.setState({saveStatusInProgress:true})
      await saveStatus({ action: 'update', status: AGENT_STATUS_CONTRACT, payload })
    } finally {
      this.setState({saveStatusInProgress:false})
    }
  }

  onSubmit = () => {
    const {
      handleSave,
      props: {
        showModal,
        validContractAmended,
        contract_status
      }
    } = this

    const contractBroken = contract_status === AGENT_CONTRACT_STATUS_CONTRACT_BROKEN

    if (!validContractAmended) {
      showModal('ContractChangeRequiredModal')
    } else if (!contractBroken) {
      showModal('ContractConfirmModal', { handleSave })
    } else {
      handleSave()
    }
  }

  validate = () => {
    const {
      contract_mls,
      contract_property_address,
      contract_amount,
      contract_close_date,
      checkReferralStatusFormValid,
      contract_status,
    } = this.props

    const payload = {
      contract_mls,
      contract_property_address,
      contract_amount,
      contract_close_date,
      contract_status,
    }

    return checkReferralStatusFormValid({ status: AGENT_STATUS_CONTRACT, payload })
  }

  componentDidMount() {
    const { resetBlurredFields } = this.props
    resetBlurredFields()
    this.validate()
  }

  componentDidUpdate() {
    if (validateTimeoutId) {
      clearTimeout(validateTimeoutId)
    }
    validateTimeoutId = setTimeout(this.validate, 200)
  }

  refreshSettlementSearchConfig = _.debounce(() => {
    const {fetchSearchConfig, hash, contractPropertyAddr} = this.props
    fetchSearchConfig(hash, contractPropertyAddr)
  }, 800)

  setField = (field, value) => {
    const { setField, isUpdatingContract, contract_status } = this.props
    if (isUpdatingContract && !contract_status) {
      setField('contract_status', 'contract-amended')
    }
    setField(field, value)
  }

  render() {
    const {
      contract_amount,
      contract_close_date,
      contract_mls,
      contract_property_address,
      hasTourInfoOrValidNote,
      isLease,
      isSelectedQualiaProvider,
      isTourUpdateNeeded,
      validContractAmount,
      validContractCloseDate,
      validContractMLS,
      validContractPropertyAddress,
      validContractStatus,
      shouldShowFirstContractSuccess,
      titleWillYouSelectAnswer,
      titleWhoIsProviderAnswer,
      titlePlacedOrderAnswer,
      shouldAskAgentQuestion,
      isReferralQualiaEnabled,
      contract_status,
      qualia_order,
      markFieldBlurred,
      contractMlsErrorMsg,
      contractAmountErrorMsg,
      contractCloseDateErrorMsg,
      isTitlePlaceOrderNowAnsweredYes,
    } = this.props

    const { saveStatusInProgress } = this.state

    const titleWillYouSelectAnswerNo = titleWillYouSelectAnswer && titleWillYouSelectAnswer[ANSWER_TYPE.YES_NO] !== 'yes'
    const answeredTitleWhoIsProvider = !titleWillYouSelectAnswerNo && titleWhoIsProviderAnswer
    const answeredTitlePlacedOrder = answeredTitleWhoIsProvider && isSelectedQualiaProvider && titlePlacedOrderAnswer
    const validTitleQuestions = titleWillYouSelectAnswer && (qualia_order || !isReferralQualiaEnabled || titleWillYouSelectAnswerNo || (answeredTitleWhoIsProvider && (!isSelectedQualiaProvider || answeredTitlePlacedOrder)))
    const shouldValidateQuestions = shouldAskAgentQuestion && contract_status !== AGENT_CONTRACT_STATUS_CONTRACT_BROKEN

    const isValid = (
      hasTourInfoOrValidNote &&
      validContractMLS &&
      validContractAmount &&
      validContractCloseDate &&
      validContractPropertyAddress &&
      validContractStatus &&
      (!shouldValidateQuestions || validTitleQuestions)
    )

    return (
      <div className="StatusContractForm">
        <div className="ReferralStatusForm__body">
          {shouldShowFirstContractSuccess &&
            <ReferralAgentSuccessHeader stage={AGENT_SUCCESS_TOUCH_STAGES.FIRST_CONTRACT} />
          }
          { isTourUpdateNeeded && <PropertyTourQuestions /> }
          <NoteField />
          <div className="StatusContractForm__subtitle">CONTRACT DETAILS</div>
          <div className="StatusContractForm__property_inputs">
            <fieldset className="AddressAutocomplete form-group">
              <label>Property Address</label>
              <AddressAutocomplete
                inputProps={{
                  value: contract_property_address,
                  onChange: value => {
                    this.setField('contract_property_address', value)
                    this.refreshSettlementSearchConfig()
                  },
                  placeholder: "123 Main Street, Austin, TX 78701",
                  onFocus: scrollToTop,
                }}
                styles={{
                  input: {fontFamily: 'Circular'}
                }} />
            </fieldset>
            <FeedbackTextbox
              label="MLS Number"
              value={contract_mls}
              placeholder="123456"
              maxLength="50"
              onChange={evt => this.setField('contract_mls', evt.target.value)}
              errorMsg={contractMlsErrorMsg}
              onFocus={scrollToTop}
              onBlur={() => markFieldBlurred('contract_mls')}
              manualClassName="FeedbackTextbox__circular"
            />
            <FeedbackTextbox
              label={isLease ? "Lease Amount" : "Contract Amount"}
              value={toCurrency(contract_amount)}
              type="text"
              pattern={"$([0-9]+,)*"}
              placeholder="$150,000"
              onChange={evt => this.setField('contract_amount', fromCurrency(evt.target.value))}
              errorMsg={contractAmountErrorMsg}
              onFocus={scrollToTop}
              onBlur={() => markFieldBlurred('contract_amount')}
              manualClassName="FeedbackTextbox__circular"
            />
            <DatePicker
              label={isLease ? "Expected Commission Date" : "Expected Close Date"}
              useNative
              value={contract_close_date}
              onChange={date => this.setField('contract_close_date', date)}
              orientation="vertical"
              futureDatesOnly
              errorMsg={contractCloseDateErrorMsg}
              onBlur={() => markFieldBlurred('contract_close_date')}
              manualClassName="circularFont"
            />
          </div>
          <ContractStatusChoices />

          {contract_status !== AGENT_CONTRACT_STATUS_CONTRACT_BROKEN && <ReferralQualiaQuestions editStatus={AGENT_STATUS_CONTRACT}/>}

        </div>
        <div className="ReferralStatusForm__footer">
          <StatusSubmitButton
            disabled={!isValid || saveStatusInProgress}
            onClick={this.onSubmit}>
            { isTitlePlaceOrderNowAnsweredYes ? "Update status & order title" : "Update status" }
          </StatusSubmitButton>
        </div>
        <ContractConfirmModal />
        <ContractChangeRequiredModal />
      </div>
    )
  }
}

const selector = createStructuredSelector({
  hasTourInfoOrValidNote: selectHasTourInfoOrValidNote,
  isLease: selectIsLease,
  isSelectedQualiaProvider: selectTitleProviderIsQualia,
  isTourUpdateNeeded: selectIsPropertyInquiryTourUpdateNeeded,
  isUpdatingContract: selectIsUpdatingContract,
  contract_amount: selectContractAmount,
  contract_close_date: selectContractCloseDate,
  contract_mls: selectContractMLS,
  contract_property_address: selectContractPropertyAddr,
  contract_status: selectContractStatus,
  note: selectNote,
  validContractAmount: selectValidContractAmount,
  validContractAmended: selectValidContractAmended,
  validContractCloseDate: selectValidContractCloseDate,
  validContractMLS: selectValidContractMLS,
  validContractPropertyAddress: selectValidContractPropertyAddress,
  validContractStatus: selectValidContractStatus,
  shouldShowFirstContractSuccess: selectShouldShowFirstContractSuccess,
  titleWillYouSelectAnswer: selectTitleWillYouSelectQuestion,
  isTitleWillYouSelectQuestionAnsweredYes: selectIsTitleWillYouSelectQuestionAnsweredYes,
  titleWhoIsProviderAnswer: selectTitleWhoIsProviderQuestion,
  titlePlacedOrderAnswer: selectTitlePlacedOrderQuestion,
  isTitlePlacedOrderQuestionAnsweredNo: selectIsTitlePlacedOrderQuestionAnsweredNo,
  titlePlaceOrderNowAnswer: selectTitlePlaceOrderNowQuestion,
  isTitlePlaceOrderNowAnsweredYes: selectIsTitlePlaceOrderNowAnsweredYes,
  newSelectionCompany: selectSettlementNewSelectionCompany,
  selectSettlement: selectSettlement,
  shouldAskAgentQuestion: selectReferralQualiaAskAgentQuestion,
  isReferralQualiaEnabled: selectReferralQualiaEnabled,
  qualia_order: selectLatestQualiaOrder,
  hash: selectAssignmentTransactionHash,
  contractMlsErrorMsg: selectContractMlsErrorMsg,
  contractAmountErrorMsg: selectContractAmountErrorMsg,
  contractCloseDateErrorMsg: selectContractCloseDateErrorMsg,
  contractPropertyAddr: selectContractPropertyAddr,
})


const actions = {
  saveStatus,
  setField,
  markFieldBlurred,
  resetBlurredFields,
  showModal: show,
  checkReferralStatusFormValid,
  fetchSearchConfig,
}

export const StatusContractForm = connect(selector, actions)(ContractForm)
